export const DATE_DISPLAY_FORMAT = 'MM/DD/YYYY';

export const DATE_SERVER_FORMAT = 'YYYY-MM-DD';

export const SCHEDULE_CODE_DATE_FORMAT = 'MM-DD-YYYY';
